module.exports = __webpack_public_path__ + "img/US.ee5bc3fb.svg";